// File: src/components/ProtectedRoute.jsx

import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  console.log('[ProtectedRoute] Rendering ProtectedRoute...');

  // 1) Access our AuthContext
  const { currentUser } = useContext(AuthContext);

  // 2) IMPORTANT: retrieve "accessToken" from localStorage 
  //    (instead of 'jwt' or 'token')
  const accessToken = localStorage.getItem('accessToken');

  // 3) Just for debugging, also see if there's a refreshToken
  const refreshToken = localStorage.getItem('refreshToken');

  const location = useLocation();

  console.log('[ProtectedRoute] accessToken =', accessToken);
  console.log('[ProtectedRoute] refreshToken =', refreshToken);
  console.log('[ProtectedRoute] currentUser =>', currentUser);

  // If there's no accessToken => user not authenticated
  if (!accessToken) {
    console.log('[ProtectedRoute] No accessToken => redirecting to /login');
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // If currentUser isn't loaded yet => show a spinner
  if (!currentUser) {
    console.log('[ProtectedRoute] currentUser is null => showing "Loading..."');
    return <div>Loading user info...</div>;
  }

  // If user is permanently banned
  if (currentUser.isBanned) {
    console.log('[ProtectedRoute] user is BANNED => redirecting to /events');
    return <Navigate to="/events" replace />;
  }

  // If user is temp-banned and not expired => redirect to /events
  const now = new Date();
  if (currentUser.isTempBanned && currentUser.tempBanExpiresAt) {
    const tempBanEnd = new Date(currentUser.tempBanExpiresAt);
    if (tempBanEnd > now) {
      console.log('[ProtectedRoute] user is TEMP-BANNED => redirecting to /events');
      return <Navigate to="/events" replace />;
    }
  }

  // If we reach here => user is allowed in
  console.log('[ProtectedRoute] Access granted => rendering children');
  return children;
}
